export default __webpack_public_path__ + "static/media/admob.79b8e2f5.svg";